<mat-card id="card" fxLayout="column" class="mainContentBody">
  <mat-card-content fxFlex [style.overflow]="'auto'" fxLayout="column" class="mainContentBodyContent">
    <h2>Risultati sondaggio</h2>

    <!-- Anagrafica sondaggio -->
    <div fxLayout="column">
      <mat-card-title>{{ sondaggio?.titolo }}</mat-card-title>
      <mat-card-subtitle>Creato da: {{ sondaggio?.creatore.nome }} {{ sondaggio?.creatore.cognome }}</mat-card-subtitle>
      <mat-card-content>
        <h3 *ngIf="sondaggio?.descrizione">{{ sondaggio?.descrizione }}</h3>
        <h5>{{ ((isSondaggioExpired()) ? 'Sondaggio scaduto il ' : 'Scadenza ') + ( sondaggio?.dataScadenza | date : 'dd/MM/yyyy':'' : locale | titlecase) }}</h5>
      </mat-card-content>
    </div>

    <!-- Dati risposte -->
    <div fxLayout="row" fxLayout.xs="column" fxLayout.sm="column">

      <div fxFlex="30" fxFlex.xs="100" fxFlex.sm="100" [class.hide]="risposteTot <= 0">
        <div id="grafico"></div>
      </div>      
      
      <div fxFlex="auto" fxLayout="column" >
        <table mat-table matTableExporter #exporter="matTableExporter" [dataSource]="dataSource" class="mat-elevation-z8">
          <!-- Nome Opzione -->
          <ng-container matColumnDef="opzione">
            <th mat-header-cell *matHeaderCellDef> Opzione </th>
            <td mat-cell *matCellDef="let o"> {{ o.option.name }} </td>
            <td mat-footer-cell *matFooterCellDef> Totale </td>
          </ng-container>
  
          <!-- Numero risposte per ogni opzione -->
          <ng-container matColumnDef="risposte">
            <th mat-header-cell *matHeaderCellDef> # risposte </th>
            <td mat-cell *matCellDef="let o">{{ o.collaboratore.length }}</td>
            <td mat-footer-cell *matFooterCellDef> {{ risposteTot }} </td>
          </ng-container>
  
          <!-- Persone che hanno risposto a quell'opzione -->
          <ng-container matColumnDef="votanti">
            <th mat-header-cell *matHeaderCellDef> Votanti </th>
            <td mat-cell *matCellDef="let o" > 
              <mat-icon *ngIf="o.collaboratore.length > 0" [matTooltip]="listaCollab(o)">groups</mat-icon>
            </td>
            <td mat-footer-cell *matFooterCellDef></td>
          </ng-container>
  
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
        </table>
      </div>
    </div>
    
  </mat-card-content>
</mat-card>

